import React from "react";
import "./About.css";

export default function About() {
  return (
    <main className="about-page">
      {/* ---------- ABOUT US ---------- */}
      <section className="about-us">
        <h1>About us</h1>
        <p>
          Kaya is a creative studio focused on strategy-led video editing. We are very passionate about pushing the boundaries of video editing to help brands stand out. 
        </p>
      </section>

      {/* ---------- OUR TEAM ---------- */}
      <section className="our-team">
        <h2>Our team</h2>
        <p>
          We’re a small, hands-on team of editors. Our team has worked on a wide variety of projects.<br></br> <br></br>We are always looking for talented editors to join our team. If you're interested, please send your resume and portfolio to hello@kayavisuals.com
        </p>
      </section>

      {/* ---------- FOOTER ---------- */}
      <footer className="site-footer">
        <div className="footer-inner">
          <nav className="footer-nav">
            <a href="/about">About</a>
            <a href="/contact">Contact</a>
            <a href="/blog">Blog</a>
          </nav>
          <p className="footer-legal">
            © {new Date().getFullYear()} Kaya Visuals · Austin, TX
          </p>
        </div>
      </footer>
    </main>
  );
}
